import React from "react";
import { Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import CrearInstitutoClassicsIndividual from "./crear-instituto-individual";

const CrearInstitutoClassics = () => {
  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Agregar un nuevo Instituto</div>
      </div>
      <Container fluid>
        <Row>
          <CrearInstitutoClassicsIndividual />
        </Row>
      </Container>
    </>
  );
};

export default CrearInstitutoClassics;
